import React from 'react';
import moment from 'moment';
import { processType } from 'constants/process-type';
import { Text, TextMessage } from 'components/tt-forms/common';
import { ContainerFileDinhKem } from 'components/upload';
import { ShowIf } from 'components/utils';
import { isArray } from 'lodash';

class HuongXuLyView extends React.Component {
  render() {
    let lblTextArea='Ý kiến xử lý';
    let dataTaiLieu = this.props.listTaiLieuVanThu;
    if (this.props.thongTinXuLyGiaiQuyet && this.props.thongTinXuLyGiaiQuyet.huongXuLy) {
      if (this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy ) {
        lblTextArea= 'Ý kiến xử lý';
      } else if (this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.luuDonVaTheoDoi ) {
        lblTextArea= 'Lý do lưu đơn';
      } else if (this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.khongXuLyNeuLyDo ) {
        lblTextArea= 'Lý do';
      } else {
        lblTextArea='Ý kiến xử lý';
      }
    }
    if (isArray(dataTaiLieu) && dataTaiLieu.length > 0) {
      dataTaiLieu = dataTaiLieu.filter(item => item.buocGiaiQuyet !== 'BO_SUNG_SAU_KHI_CHUYEN_DON_LUU_HO_SO');
    }
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    return (
      <div className="items-form mb5">
        <div className="row pl10 pr10">
          <Text
            className="col-input"
            label="Hướng xử lý:"
            value={this.props.thongTinXuLyGiaiQuyet.huongXuLy === null ? this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy : (this.props.thongTinXuLyGiaiQuyet.huongXuLy && this.props.thongTinXuLyGiaiQuyet.huongXuLy.ten) || ''} />
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.huongXuLy != null &&
            this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri != processType.xuLyDon.huongXuLy.yeuCauGapLanhDao &&
            this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri != processType.xuLyDon.huongXuLy.luuDonVaTheoDoi}>
            <Text
              className="col-input"
              label="Nhóm thẩm quyền giải quyết:"
              value={this.props.thongTinXuLyGiaiQuyet.thamQuyenGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.thamQuyenGiaiQuyet.ten : ''} />
          </ShowIf>
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.huongXuLy === null && this.props.thongTinXuLyGiaiQuyet.quyTrinhXuLy !== ''}>
            <div className="col-input">
              <label className="pt-label">
                <span className="val-title-bold">Phòng ban tiếp nhận:</span>
                <p className="val-content">{this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh && this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh.ten ? this.props.thongTinXuLyGiaiQuyet.phongBanXuLyChiDinh.ten : ''}</p>
              </label>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.huongXuLy != null &&
            this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.deXuatThuLy}>
            <Text
              className="col-input"
              label="Hạn giải quyết:"
              red={true}
              value={this.props.thongTinXuLyGiaiQuyet.hanGiaiQuyet ? moment(this.props.thongTinXuLyGiaiQuyet.hanGiaiQuyet).format('DD/MM/YYYY') : ''} />
          </ShowIf>
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.huongXuLy != null &&
            this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.chuyenDon}>
            <div className="col-input">
              <label className="pt-label">
                <span className="val-title-bold">Cơ quan tiếp nhận:</span>
                <p className="val-content">{this.props.thongTinXuLyGiaiQuyet.coQuanTiepNhan && this.props.thongTinXuLyGiaiQuyet.coQuanTiepNhan.id ? this.props.thongTinXuLyGiaiQuyet.coQuanTiepNhan.ten : (this.props.thongTinXuLyGiaiQuyet.donViNgoaiHeThong ? this.props.thongTinXuLyGiaiQuyet.donViNgoaiHeThong.ten : '')}</p>
              </label>
            </div>
          </ShowIf>
          <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.huongXuLy != null &&
            this.props.thongTinXuLyGiaiQuyet.huongXuLy.giaTri == processType.xuLyDon.huongXuLy.yeuCauGapLanhDao}>
            <div className="col-input">
              <label className="pt-label">
                <span className="val-title-bold">Ngày hẹn:</span>
                <p className="val-content">{this.props.thongTinXuLyGiaiQuyet.ngayHenGapLanhDao ? moment(this.props.thongTinXuLyGiaiQuyet.ngayHenGapLanhDao).format('DD/MM/YYYY') : ''}</p>
              </label>
            </div>
            <div className="col-input">
              <label className="pt-label">
                <span className="val-title-bold">Địa điểm:</span>
                <p className="val-content">{this.props.thongTinXuLyGiaiQuyet.diaDiem ? this.props.thongTinXuLyGiaiQuyet.diaDiem : ''}</p>
              </label>
            </div>
          </ShowIf>
        </div>
        <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.huongXuLy != null &&
          this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null
          && (this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'TU_TTXM' || this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'GIAO_TTXM')}>
          <div className="row pl10 pr10">
            <Text
              className="col-input"
              label="Quy trình giải quyết:"
              value={this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null ? this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.ten : ''} />
            <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null && this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'TU_TTXM'}>
              <Text
                className="col-input"
                label="Phòng ban giải quyết:"
                value={this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyet ? this.props.thongTinXuLyGiaiQuyet.phongBanGiaiQuyet.ten : ''} />
              <Text
                className="col-input"
                label="Công chức giải quyết:"
                value={this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh ? this.props.thongTinXuLyGiaiQuyet.canBoXuLyChiDinh.ten : ''} />
            </ShowIf>
            <ShowIf condition={this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM != null && this.props.thongTinXuLyGiaiQuyet.mapTrangThaiTTXM.enum == 'GIAO_TTXM'}>
              <Text
                className="col-input"
                label={"Đơn vị "+lb1+":"}
                value={this.props.thongTinXuLyGiaiQuyet.donViThamTraXacMinh ? this.props.thongTinXuLyGiaiQuyet.donViThamTraXacMinh.ten : ''} />

              <Text
                className="col-input"
                red={true}
                label="Thời gian báo cáo kết quả:"
                value={this.props.thongTinXuLyGiaiQuyet.thoiHanBaoCaoKetQuaTTXM ? moment(this.props.thongTinXuLyGiaiQuyet.thoiHanBaoCaoKetQuaTTXM).format('DD/MM/YYYY') : ''} />

            </ShowIf>
          </div>
        </ShowIf>
        <div className="row pl10 pr10 mt15">
          <TextMessage
            className="col-12"
            value={this.props.thongTinXuLyGiaiQuyet.yKienXuLy || ''}
            label={lblTextArea} />
        </div>
        <div className="container-filedinhkem">
          <ContainerFileDinhKem label="Danh sách văn bản xử lý" disableAttachFile={true} bindValidator={this} dataShow={dataTaiLieu} />
        </div>
      </div>
    )
  }
}

export default HuongXuLyView;


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/form-xu-ly/chuyen-vien/HuongXuLyView.jsx